import DepartmentDeleteModal from "./DepartmentDeleteModal";

export default DepartmentDeleteModal;
